"use strict";

module.exports = {
  'name': 'help',
  'category': 'Expression',
  'syntax': ['help(object)', 'help(string)'],
  'description': 'Display documentation on a function or data type.',
  'examples': ['help(sqrt)', 'help("complex")'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/expression/help.js
// module id = 876
// module chunks = 0